import { Language } from '../translations'

export const tabsTranslations: Record<string, Record<Language, string>> = {
  skills: { en: "Skills", fi: "Osaamiset" },
  workHistory: { en: "Work history", fi: "Työhistoria" },
  projectHistory: { en: "Project history", fi: "Projektihistoria" },
  certificates: { en: "Certificates", fi: "Sertifikaatit" },
  education: { en: "Education", fi: "Koulutus" },
  hobbies: { en: "Hobbies", fi: "Harrastukset" },
  documents: { en: "Documents", fi: "Dokumentit" },
};